/* Change this file to get your personal Portfolio */

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation";

const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 2000
};

const illustration = {
  animated: true
};

const greeting = {
  username: "Faizan Ahmad",
  title: "Hi all, I'm Faizan",
  subTitle: emoji(
    "A passionate Web Developer 🚀 building applications using React.js, Node.js and modern JavaScript."
  ),
  resumeLink: "", // removed resume button
  displayGreeting: true
};

const socialMediaLinks = {
  github: "https://github.com/111faizan",
  linkedin: "https://www.linkedin.com/in/faizanahmad77",
  gmail: "111faizanah@gmail.com",
  display: true
};

const skillsSection = {
  title: "What I do",
  subTitle: "FULL STACK WEB DEVELOPER",
  skills: [
    emoji("⚡ Build responsive and interactive web applications"),
    emoji("⚡ Develop REST APIs using Node.js & Express"),
    emoji("⚡ Work with databases like MongoDB & MySQL")
  ],
  softwareSkills: [
    { skillName: "HTML5", fontAwesomeClassname: "fab fa-html5" },
    { skillName: "CSS3", fontAwesomeClassname: "fab fa-css3-alt" },
    { skillName: "JavaScript", fontAwesomeClassname: "fab fa-js" },
    { skillName: "ReactJS", fontAwesomeClassname: "fab fa-react" },
    { skillName: "NodeJS", fontAwesomeClassname: "fab fa-node" },
    { skillName: "MongoDB", fontAwesomeClassname: "fas fa-database" },
    { skillName: "Git", fontAwesomeClassname: "fab fa-git-alt" },
    { skillName: "Python", fontAwesomeClassname: "fab fa-python" }
  ],
  display: true
};

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "Kendriya Vidyalaya Rajouri",
      logo: require("./assets/images/harvardLogo.png"),
      subHeader: "Secondary & Higher Secondary Education",
      descBullets: ["10th & 12th Completed"]
    },
    {
      schoolName: "L.D College of Engineering",
      logo: require("./assets/images/stanfordLogo.png"),
      subHeader: "B.E. in Information Technology",
      descBullets: ["2021 - 2025"]
    }
  ]
};

const techStack = {
  viewSkillBars: true,
  experience: [
    { Stack: "Frontend", progressPercentage: "90%" },
    { Stack: "Backend", progressPercentage: "75%" },
    { Stack: "Programming", progressPercentage: "70%" }
  ],
  displayCodersrank: false
};

const workExperiences = {
  display: false,
  experience: []
};

const openSource = {
  showGithubProfile: false,
  display: false
};

const bigProjects = {
  title: "Projects",
  subtitle: "Some projects I built for learning and real-world practice",
  projects: [
    // 🔹 New Projects Added
    {
      projectName: "Movies Search App",
      projectDesc:
        "React.js web app to search movies, view details and save to Watch Later list using public Movie API.",
      footerLink: [
        {
          name: "Live Website",
          url: "https://movies-search.pages.dev/"
        },
        {
          name: "GitHub",
          url: "https://github.com/111faizan/Movies_Search"
        }
      ]
    },
    {
      projectName: "React Video Streaming Website (YouTube Clone)",
      projectDesc:
        "YouTube clone built with React.js allowing users to search and stream videos using YouTube API.",
      footerLink: [
        {
          name: "Live Website",
          url: "https://react-video-streaming-app.pages.dev/"
        },
        {
          name: "GitHub",
          url: "https://github.com/111faizan/React-Video-Streaming-App"
        }
      ]
    },
    {
      projectName: "E-commerce Shopping Website",
      projectDesc:
        "Frontend-only e-commerce platform built using HTML, CSS and JavaScript.",
      footerLink: [
        {
          name: "Live Website",
          url: "https://ecommerce-page.pages.dev/"
        },
        {
          name: "GitHub",
          url: "https://github.com/111faizan/ecommerce_page"
        }
      ]
    },

    // 🔹 Old Projects Kept
    {
      projectName: "Quick Darshan - Live Streaming Platform",
      projectDesc:
        "Live streaming platform built using React and Node.js for real-time broadcasting.",
      footerLink: [
        {
          name: "Live Website",
          url: "https://quickdarshan.vercel.app/"
        },
        {
          name: "GitHub",
          url: "https://github.com/111faizan/quickdarshan"
        }
      ]
    },
    {
      projectName: "VideoTube Backend API",
      projectDesc:
        "REST API providing authentication, video management, likes, comments and playlists.",
      footerLink: [
        {
          name: "Live API",
          url: "https://videotube-api-rnfv.onrender.com/"
        },
        {
          name: "GitHub",
          url: "https://github.com/111faizan/VideoTube"
        }
      ]
    },
    {
      projectName: "Banking Website",
      projectDesc:
        "Built using HTML, CSS, PHP, JavaScript and MySQL with basic banking functionality.",
      footerLink: [
        {
          name: "GitHub",
          url: "https://github.com/111faizan/banking_website.git"
        }
      ]
    },
    {
      projectName: "Hotel Booking Website",
      projectDesc:
        "Hotel booking management system using PHP, MySQL and JavaScript.",
      footerLink: [
        {
          name: "GitHub",
          url: "https://github.com/111faizan/Hotel-Management-System"
        }
      ]
    },
    {
      projectName: "Travel Website",
      projectDesc:
        "Basic travel package website created using HTML, CSS and JavaScript.",
      footerLink: [
        {
          name: "GitHub",
          url: "https://github.com/111faizan/travel_website.git"
        }
      ]
    },
    {
      projectName: "Simple Dice Game",
      projectDesc:
        "A simple dice game built using HTML, CSS and JavaScript.",
      footerLink: [
        {
          name: "Live Website",
          url: "https://simple-dice-game.pages.dev/"
        },
        {
          name: "GitHub",
          url: "https://github.com/111faizan/simple_dice_game.git"
        }
      ]
    }
  ],
  display: true
};

const achievementSection = { display: false };
const blogSection = { display: false };
const talkSection = { display: false };
const podcastSection = { display: false };
const resumeSection = { display: false };

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "Feel free to reach out for collaboration or opportunities.",
  email_address: "111faizanah@gmail.com"
};

const twitterDetails = {
  userName: "faizan14228970",
  display: false
};

const isHireable = true;

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
